import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import ApplicationPaginatedResource from './ApplicationPaginatedResource';
import glue from '../glue';
export var PageStatus;

(function (PageStatus) {
  PageStatus["DRAFT"] = "DRAFT";
  PageStatus["REVIEW"] = "REVIEW";
  PageStatus["PUBLISHED"] = "PUBLISHED";
  PageStatus["UNPUBLISHED"] = "UNPUBLISHED";
})(PageStatus || (PageStatus = {}));

var AdminPageResource = /*#__PURE__*/function (_ApplicationPaginated) {
  _inherits(AdminPageResource, _ApplicationPaginated);

  var _super = _createSuper(AdminPageResource);

  function AdminPageResource() {
    var _this;

    _classCallCheck(this, AdminPageResource);

    _this = _super.apply(this, arguments);
    _this.id = '';
    _this.title = 'Nouvelle page sans titre';
    _this.status = PageStatus.DRAFT;
    _this.website = glue.websites[0].code;
    return _this;
  }

  _createClass(AdminPageResource, [{
    key: "pk",
    value: function pk() {
      return this.id;
    }
  }]);

  return AdminPageResource;
}(ApplicationPaginatedResource);

export { AdminPageResource as default };
AdminPageResource.resource = '/admin/pages';